import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { productConnectivityStates, titleForProductConnectivityState } from 'zens-store'

interface Props extends Omit<SelectProps<number | number[]>, 'items' | 'onSelect'> {
  onChange?: (value: number | number[]) => void
}
const ConnectivitySelect = (props: Props) => {
  const { onChange, value, ...otherProps } = props
  const { t } = useTranslation()

  const items = productConnectivityStates.map((status) => ({
    value: status,
    title: titleForProductConnectivityState(status, t),
  }))
  return (
    <Select
      value={value || 'all'}
      onSelect={onChange}
      items={items}
      testID="ConnectivitySelect.Container"
      {...otherProps}
    />
  )
}

export default ConnectivitySelect
